import type { PublicMerchant } from '~~/models/Merchant';

/**
 * Provides the app-wide active merchant.
 *
 * Use this composable when you're outside the main [merchantSlug].vue context
 * (e.g., in a global header) and need to know which merchant (if any) is active.
 *
 * Naturally, this can be `null` if no merchant is selected.
 */
export const useGlobalMerchant = () => {
	return useState<PublicMerchant | null>('global-active-merchant', () => null);
};
